module.exports = __webpack_public_path__ + "static/media/hilda_in_her_training_gear_by_corriger-dasn7x3.ec67fd22.png";